const extractInvoiceData = async (file) => {
  console.log("📄 Uploading invoice to backend...");

  const formData = new FormData();
  formData.append("file", file); // Append the file to form data
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "http://localhost:5000"; // Default for dev

  
  try {
    const response = await fetch(`${BACKEND_URL}/parse-invoice`, {
      method: "POST",
      body: formData, // Send as multipart/form-data
    });

    console.log("🔄 Response Status:", response.status);
    
    // ✅ Log raw response before parsing
    const textResponse = await response.text();
    console.log("📝 Raw Response from Backend:", textResponse);

    if (!response.ok) {
      throw new Error(`❌ Failed to process invoice (Status: ${response.status})`);
    }

    // ✅ Parse JSON and return full response (invoiceData + pdfFile)
    return JSON.parse(textResponse);

  } catch (error) {
    console.error("❌ Error processing invoice:", error);
    return null;
  }
};

export default extractInvoiceData;
